
import React from 'react';
import PropTypes from 'prop-types';
import { UpdateButton, DeleteButton, PrintButton, QrCodeButton, MailButton, AttachButton, ChangeStatusButton } from 'components/controls';

const DefaultActions = ({
  row,
  onEdit,
  onDelete,
  onPrint,
  onQrCode,
  onMail,
  onAttach,
  onChangeStatus,
  children,
  updatePermissions = '',
  deletePermissions = '',
  changeStatusPermissions = "",
  printPermissions = '',
  qrCodePermissions = '',
  mailPermissions = '',
  attachPermissions = '',
  disabledUpdate,
  disabledDelete,
  disabledPrint,
  disabledQrCode,
  disabledMail,
  disabledAttach
}) => {
  let totalWidth = 0;

  // Función para incrementar el ancho total si la función está presente
  const incrementWidth = () => {
    totalWidth += 42; // Incrementa en 40 por cada botón
  };

  // Verificar qué botones están presentes y agregar su ancho al total
  if (onEdit) incrementWidth();
  if (onDelete) incrementWidth();
  if (onPrint) incrementWidth();
  if (onQrCode) incrementWidth();
  if (onMail) incrementWidth();
  if (onAttach) incrementWidth();
  if (onChangeStatus) incrementWidth();

  return (
    <div style={{ width: `${totalWidth}px`, display: 'flex', justifyContent: 'space-between' }}>
      {onEdit && (
        <UpdateButton style={{ display: 'inline-block' }} onClick={() => onEdit(row)} requiredPermissions={updatePermissions} disabled={disabledUpdate} />
      )}
      {onDelete && (
        <DeleteButton style={{ display: 'inline-block' }} onClick={() => onDelete(row)} requiredPermissions={deletePermissions} disabled={disabledDelete} />
      )}
      {onChangeStatus && (
        <ChangeStatusButton onClick={() => onChangeStatus(row)} requiredPermissions={changeStatusPermissions} disabled={disabledDelete} />
      )}
      {onPrint && (
        <PrintButton style={{ display: 'inline-block' }} onClick={() => onPrint(row)} requiredPermissions={printPermissions} disabled={disabledPrint} />
      )}
      {onQrCode && (
        <QrCodeButton style={{ display: 'inline-block' }} onClick={() => onQrCode(row)} requiredPermissions={qrCodePermissions} disabled={disabledQrCode} />
      )}
      {onMail && (
        <MailButton style={{ display: 'inline-block' }} onClick={() => onMail(row)} requiredPermissions={mailPermissions} disabled={disabledMail} />
      )}
      {onAttach && (
        <AttachButton style={{ display: 'inline-block' }} onClick={() => onAttach(row)} requiredPermissions={attachPermissions} disabled={disabledAttach} />
      )}
      {children}
    </div>
  );
};

DefaultActions.propTypes = {
  // Data del registro a retornar
  row: PropTypes.oneOfType([PropTypes.object]),
  // Funcion para el UpdateButton
  onEdit: PropTypes.func,
  // Funcion para el DeleteButton
  onDelete: PropTypes.func,
  // Funcion para el ChangeStatusButton
  onChangeStatus: PropTypes.func,
  // Funcion para el PrintButton
  onPrint: PropTypes.func,
  // Funcion para el QrCodeButton
  onQrCode: PropTypes.func,
  // Funcion para el MailButton
  onMail: PropTypes.func,
  // Funcion para el AttachButton
  onAttach: PropTypes.func,
  // Componentes adicionales
  children: PropTypes.node,
  // Permisos para editar
  updatePermissions: PropTypes.string,
  // Permisos para eliminar
  deletePermissions: PropTypes.string,
  // Permisos para cambiar estado
  changeStatusPermissions: PropTypes.string,
  // Permisos para imprimir
  printPermissions: PropTypes.string,
  // Permisos para Generar Qr code
  qrCodePermissions: PropTypes.string,
  // Permisos para mail
  mailPermissions: PropTypes.string,
  // Permisos para Attach
  attachPermissions: PropTypes.string,

  disabledUpdate: PropTypes.bool,
  disabledDelete: PropTypes.bool,
  disabledPrint: PropTypes.bool,
  disabledQrCode: PropTypes.bool,
  disabledMail: PropTypes.bool,
  disabledAttach: PropTypes.bool
};

export default DefaultActions;
